import {
  Box,
  ButtonGroup,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import ButtonRemoveResource from 'components/ButtonRemoveResource';
import ButtonEdit from 'components/ui/ButtonEdit';
import TagHeader from 'components/ui/TagHeader';
import { useListsByTags } from '../hooks/useListsByTags';
import { useSearchParams } from 'react-router-dom';

export default function ListsTagView() {
  const [searchParams] = useSearchParams();
  const tags = useListsByTags();

  if (!tags) return null;

  return (
    <Stack spacing="50px">
      {tags.map((tag) => (
        <Box key={`tag-${tag.id}`}>
          <TagHeader
            name={tag.name}
            colorScheme={tag.colorScheme}
            description={`${tag.lists.length} listas distribuídas em ${tag.companies} clientes`}
          />
          <TableContainer mt="23px">
            <Table>
              <Thead>
                <Tr>
                  <Th>Nome da lista</Th>
                  <Th w="150px">Lista de newsletter / Revisão</Th>
                  <Th w="350px">Empresa</Th>
                  <Th w="160px"></Th>
                </Tr>
              </Thead>
              <Tbody>
                {tag.lists.map((list) => (
                  <Tr key={`row-${list.id}`}>
                    <Td>{list.name}</Td>
                    <Td>
                      {list.isNewsletter
                        ? `Sim / ${list.requiresReview ? 'Sim' : 'Não'}`
                        : 'Não'}
                    </Td>
                    <Td>{list.company.name}</Td>
                    <Td textAlign="right">
                      <ButtonGroup>
                        <ButtonEdit
                          to={`/listas-de-disparo/${list.id}${searchParams.size > 0 ? `?${searchParams}` : ''}`}
                        />
                        <ButtonRemoveResource
                          id={list.id}
                          pathName="lists"
                          queryKey="search-lists"
                        />
                      </ButtonGroup>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      ))}
    </Stack>
  );
}
